import {
  APPLY_PROMO,
  BRANCH_BASED_THIRD_FETCH,
  CATEGORY_PRODUCT_LIST_FETCH,
  CHANGE_LANGUAGE,
  CLEAR_CART,
  DELIVERY_CHARGES_SECOND_FETCH,
  EDIT_BOOKING,
  EDIT_CART,
  EDIT_CART_PROMO_ITEM,
  EDIT_OPTION,
  FETCH_BRANCH,
  FETCH_STORE,
  LOAD_OPTIONS,
  PRODUCTS_SECOND_FETCH,
  REDUCE_QUANTITY,
  REMOVE_FROM_CART,
  REMOVE_FROM_CART_PROMO_ITEM,
  RESET_DELIVERY_TYPE,
  RESET_TO_INITIAL_STATE,
  SAVE_SEARCH,
  SECOND_LOADING,
  SET_CATEGORIES_MIN_ORDER,
  SET_IS_PREORDERING_FALSE,
  SET_LANGUAGE,
  SET_NON_MINGLED_CATEGORY,
  SET_PREP_AND_LEAD_TIME,
  SET_PRODUCT,
  SET_USED_COMPONENTS,
  UPDATE_MOV,
  UPDATE_PROMOTION,
  LOAD_PRODUCT_DETAILS,
  LOAD_BRANCH_DETAILS,
} from "./actionTypes";
import instance from "./instance";
import axios from "axios";
import { preciseNumber } from "../reducers/cart";
import {
  getProduct,
  getProductInventory,
  reduceComponentsInventories,
} from "../reducers/store";
import { getParentCategories } from "../../Components/Menu/Helpers";
import { parse } from "date-fns";
import React from "react";

let item_index = 0;
let cart_quantity = 0;
Number.prototype.clamp = function (min, max) {
  return Math.min(Math.max(this, min), max);
};

function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

export const getAllowableInventory = (inventory, increments, minQuantity) => {
  const allowableInventory = Math.trunc(inventory / increments) * increments;
  return allowableInventory > 0 ? allowableInventory : minQuantity;
};
export const changeLanguage = () => {
  return {
    type: CHANGE_LANGUAGE,
  };
};
export const setLanguage = (lan) => {
  return {
    type: SET_LANGUAGE,
    payload: lan,
  };
};
export const Reduce_Quantity = (product, quantity) => {
  return {
    type: REDUCE_QUANTITY,
    payload: { product, quantity },
  };
};

function TestPreorderdItem(
  item,
  store_product,
  product_index,
  dispatch,
  usedComponents
) {
  if (
    !item.is_preordered ||
    !["stocked", "composite"].includes(store_product.type_of_product) ||
    item.promo
  ) {
    return true;
  } else if (item.is_preordered) {
    if (getProductInventory(store_product, usedComponents) > 0) {
      item.is_preordered = false;
      dispatch({
        type: SET_IS_PREORDERING_FALSE,
        payload: { product: product_index },
      });

      return true;
    } else if (
      store_product.allow_preordering &&
      store_product.preorder_inventory > 0
    ) {
      return true;
    }
  }
  return false;
}

const Edit_Cart = (
  item_quantity,
  store_price,
  store_is_delivered,
  store_charge_delivery,
  preparation_time,
  preordering_leadtime,
  smart_promos,
  is_promo_item = false,
  promo_item_index
) => {
  if (is_promo_item) {
    return {
      type: EDIT_CART_PROMO_ITEM,
      payload: {
        product: promo_item_index,
        quantity: item_quantity,
        price: 0,
        is_delivered: store_is_delivered,
        charge_delivery: store_charge_delivery,
        preparation_time: preparation_time,
        preordering_leadtime: preordering_leadtime,
      },
    };
  } else {
    return {
      type: EDIT_CART,
      payload: {
        product: item_index,
        quantity: item_quantity,
        price: store_price,
        is_delivered: store_is_delivered,
        charge_delivery: store_charge_delivery,
        preparation_time: preparation_time,
        preordering_leadtime: preordering_leadtime,
      },
      smart_promos: smart_promos,
    };
  }
};
export const Apply_Promo = (promotion) => {
  return async (dispatch, getState) => {
    const smart_promos = getState().store?.store?.smart_promos || [];
    const storeSettings = getState().store?.store?.settings || {};
    const customer = getState().customers;
    const branchDetails = getState().branch;
    const authUser = getState().auth.user;
    const storeCategories = getState()?.store?.store?.categories || [];
    dispatch({
      type: APPLY_PROMO,
      payload: promotion,
      smart_promos,
      customerAddress: customer?.address || {},
      customerBin: customer?.bin || {},
      branchDetails: branchDetails,
      authUser: authUser,
      storeCategories: storeCategories,
      storeSettings,
    });
  };
};

const Check_Promo = async (promo, store, branch_details, dispatch, channel) => {
  const branch_id = branch_details ? branch_details.branch : null;
  let store_promo;
  if (!promo.is_private) {
    if (!promo.isSmartPromo) {
      store_promo = store.promos.find(
        (store_promo) => store_promo.id === promo.id
      );
    } else {
      store_promo = store.smart_promos.find(
        (store_promo) => store_promo.id === promo.id
      );
      if (store_promo) {
        store_promo = {
          promo: store_promo,
          id: store_promo.id,
          code: store_promo.code,
          isSmartPromo: true,
          is_private: false,
        };
      }
    }
  } else {
    try {
      store_promo = await instance.post("coupon/", {
        code: promo.code,
        branch: branch_id,
        channel: channel,
      });
      store_promo = store_promo.data;
    } catch {
      store_promo = null;
    }
  }
  dispatch({
    type: APPLY_PROMO,
    payload: store_promo,
    InCheckCart: true,
    smart_promos: store.smart_promos,
  });
};

export const updateMOV = (mov) => {
  return {
    type: UPDATE_MOV,
    payload: mov,
  };
};

const Edit_Options = (
  item,
  store_product,
  usedComponents,
  categories,
  ChangePrepTime,
  dispatch
) => {
  let choice;
  let item_choice;
  let option_group;
  let keys = Object.keys(item.options);
  let key;
  let shouldRemoveProduct = false;
  let newUsedComponents = {};
  for (let keyIndex = 0; keyIndex < keys.length; keyIndex++) {
    if (shouldRemoveProduct) break;
    key = keys[keyIndex];
    const key_option_group = key.split("-")?.[1]; // OptionGroup model
    option_group = store_product.options.find(
      (option) => option.id === parseInt(key)
    );
    if (
      key_option_group &&
      !store_product.options_groups.some(
        (og) => og.id == parseInt(key_option_group)
      )
    ) {
      option_group = null;
    }

    if (option_group) {
      for (var option_key in item.options[key].selectedOptions) {
        choice = option_group.choices.find(
          (choice) => choice.id === parseInt(option_key)
        );
        item_choice = item.options[key].selectedOptions[option_key];

        if (
          choice &&
          (!option_group.is_required ||
            item.options[key].selected >= option_group.minimum) &&
          item.options[key].selected <= (option_group.maximum || Infinity) &&
          Boolean(item.options[key].quantityExclusive) ==
            option_group.quantity_exclusive &&
          item_choice.quantity <= (choice.maximum || Infinity) &&
          Boolean(item_choice.related_product) ==
            Boolean(choice.related_product)
        ) {
          item_choice.modifier = choice.modifier;

          if (choice.price !== item_choice.price) {
            dispatch({
              type: EDIT_OPTION,
              payload: {
                product: item.promo
                  ? Math.abs(cart_quantity - item_index)
                  : item_index,
                choice: option_key,
                price: choice.price,
                group_id: key,
                is_promo_item: item.promo ? true : false,
              },
            });
          }

          if (choice.related_product) {
            if (
              item_choice.related_product?.id !== choice.related_product?.id ||
              item_choice.related_product?.parent !==
                choice.related_product?.parent ||
              item_choice.related_product?.category_id !==
                choice.related_product?.category_id
            ) {
              shouldRemoveProduct = true;
              break;
            }

            if (item_choice.preparationTime !== choice.preparation_time) {
              item_choice.preparationTime = choice.preparation_time;

              ChangePrepTime = true;
            }

            item_choice.maxInventory = choice.inventory;
            if (item_choice.maxInventory !== null) {
              const selectedQuantity = item_choice.quantity;
              const modifierQuantity =
                (!option_group.quantity_exclusive &&
                  selectedQuantity * item.quantity) ||
                selectedQuantity;

              if (choice.related_product.type_of_product === "stocked") {
                usedComponents[choice.related_product.id] =
                  (usedComponents[choice.related_product.id] || 0) +
                  modifierQuantity;
              } else if (
                choice.related_product.type_of_product === "composite"
              ) {
                Object.entries(choice.related_product.components).forEach(
                  ([productId, product]) => {
                    usedComponents[productId] =
                      (usedComponents[productId] || 0) +
                      modifierQuantity * product.required_amount;
                  }
                );
              }

              if (
                getProductInventory(choice.related_product, usedComponents) < 0
              ) {
                shouldRemoveProduct = true;
                break;
              }
            }
          }
        } else {
          shouldRemoveProduct = true;
          break;
        }
      }
    } else {
      shouldRemoveProduct = true;
      break;
    }
  }
  if (shouldRemoveProduct) {
    dispatch({
      type: !item.promo ? REMOVE_FROM_CART : REMOVE_FROM_CART_PROMO_ITEM,
      payload: !item.promo ? item_index : Math.abs(cart_quantity - item_index),
    });
    if (!item.promo) cart_quantity--;
    item_index--;
  } else {
    Object.entries(newUsedComponents).forEach(
      ([relatedProductID, quantity]) => {
        usedComponents[relatedProductID] =
          (usedComponents[relatedProductID] || 0) + quantity;
      }
    );
  }
  return [usedComponents, ChangePrepTime];
};

const checkServiceIfAvailable = async (resource_id, product_id, slot) => {
  let res = null;
  res = await instance.post(`/get_product_resource_slots/`, {
    pid: product_id,
    resource: resource_id,
    additional_slots: [],
  });

  if (res.data.success) {
    if (res.data.slots.find((s) => s.id == slot)) return true;
  }

  return false;
};
const CheckCart = async (
  cart,
  promo,
  store,
  dispatch,
  smart_promos,
  applied_discounts,
  branch_details,
  channel = "web"
) => {
  try {
    let ChangePrepTime = false;
    let usedComponents = {};
    if (cart.length) {
      let itemWasRemoved;
      let store_product;
      item_index = 0;
      let item = {};

      const cart_length = cart.length;
      for (let i = 0; i < cart_length; i++) {
        item = cart[i];
        itemWasRemoved = false;
        try {
          store_product = store.categories.find(
            (category) => category.id === item.category_id
          );

          if (item.parent) {
            store_product = store_product.products
              .find((parent) => parent.id === item.parent)
              .children.find((product) => product.id === item.id);
          } else {
            store_product = store_product.products.find(
              (product) => product.id === item.id
            );
          }
        } catch (err) {
          store_product = null;
        }

        if (
          store_product &&
          ((!item.is_preordered &&
            (getProductInventory(store_product, usedComponents) >=
              store_product.min_addable_quantity ||
              ["produced", "digital", "bookable", "service"].includes(
                store_product.type_of_product
              ))) ||
            (item.is_preordered && store_product.preorder_inventory > 0)) &&
          (!store_product.has_required_options ||
            check_required_options(store_product, item.options)) &&
          item &&
          (item.no_mingling === store_product.no_mingling ||
            item.no_mingling === undefined) &&
          item.pickup_only === store_product.pickup_only &&
          item.delivery_only === store_product.delivery_only &&
          item.cash_only === store_product.cash_only &&
          item.credit_only === store_product.credit_only &&
          (item.promo ||
            store_product.max_addable_quantity === null ||
            item.quantity <= store_product.max_addable_quantity) &&
          Boolean(item.category_no_mingling) ===
            store_product.category_no_mingling &&
          TestPreorderdItem(
            item,
            store_product,
            item_index,
            dispatch,
            usedComponents
          ) &&
          !store_product.not_available
        ) {
          /// Update Fields
          item.category_is_child = store_product.category_is_child;
          item.publishedDate = store_product.published_date;
          item.preparation_time_threshold =
            store_product.preparation_time_threshold;
          if (
            (store_product.price !== item.price && !item.promo) ||
            store_product.is_delivered !== item.is_delivered ||
            store_product.charge_delivery !== item.charge_delivery ||
            item.preparation_time !== store_product.preparation_time ||
            item.preordering_leadtime !== store_product.preordering_leadtime
          ) {
            dispatch(
              Edit_Cart(
                item.quantity,
                store_product.price,
                store_product.is_delivered,
                store_product.charge_delivery,
                store_product.preparation_time,
                store_product.preordering_leadtime,
                smart_promos,
                item.promo ? true : false,
                Math.abs(cart_quantity - item_index)
              )
            );

            ChangePrepTime = true;
          }

          if (store_product.type_of_product === "stocked") {
            const currentProductInventory = getProductInventory(
              store_product,
              usedComponents
            );
            if (item.is_preordered) {
              if (store_product.preorder_inventory - item.quantity < 0) {
                let allowableInventory = getAllowableInventory(
                  store_product.preorder_inventory,
                  store_product.increments,
                  store_product.min_addable_quantity
                );
                dispatch(
                  Edit_Cart(
                    allowableInventory,
                    store_product.price,
                    store_product.is_delivered,
                    store_product.charge_delivery,
                    store_product.preparation_time,
                    store_product.preordering_leadtime,
                    smart_promos,
                    item.promo ? true : false,
                    Math.abs(cart_quantity - item_index)
                  )
                );
                store_product.preorder_inventory = preciseNumber(
                  store_product.preorder_inventory - allowableInventory
                );
              } else {
                store_product.preorder_inventory = preciseNumber(
                  store_product.preorder_inventory - item.quantity
                );
              }
            } else {
              if (currentProductInventory - item.quantity < 0) {
                let allowableInventory = getAllowableInventory(
                  currentProductInventory,
                  store_product.increments,
                  store_product.min_addable_quantity
                );

                dispatch(
                  Edit_Cart(
                    allowableInventory,
                    store_product.price,
                    store_product.is_delivered,
                    store_product.charge_delivery,
                    store_product.preparation_time,
                    store_product.preordering_leadtime,
                    smart_promos,
                    item.promo ? true : false,
                    Math.abs(cart_quantity - item_index)
                  )
                );

                usedComponents[store_product.id] =
                  (usedComponents[store_product.id] || 0) + allowableInventory;
              } else {
                usedComponents[store_product.id] =
                  (usedComponents[store_product.id] || 0) + item.quantity;
              }
            }
          } else if (store_product.type_of_product === "bookable") {
            let store_product_booking_slot = store_product.booking_slots.find(
              (slot) => slot.id === item.booking_slot
            );
            if (
              !store_product_booking_slot ||
              store_product_booking_slot.inventory <= 0
            ) {
              dispatch({
                type: !item.promo
                  ? REMOVE_FROM_CART
                  : REMOVE_FROM_CART_PROMO_ITEM,
                payload: !item.promo
                  ? item_index
                  : Math.abs(cart_quantity - item_index),
              });
              item_index--;
              if (!item.promo) cart_quantity--;
              itemWasRemoved = true;
            } else {
              if (store_product_booking_slot.inventory < item.quantity) {
                dispatch({
                  type: EDIT_BOOKING,
                  payload: {
                    product: item.promo
                      ? Math.abs(cart_quantity - item_index)
                      : item_index,
                    quantity: store_product_booking_slot.inventory,
                    slot_id: item.booking_slot,
                    is_promo_item: item.promo ? true : false,
                  },
                });

                store_product_booking_slot.inventory = 0;
              } else {
                store_product_booking_slot.inventory = preciseNumber(
                  store_product_booking_slot.inventory - item.quantity
                );
              }
            }
          } else if (store_product.type_of_product === "service") {
            let isRemoved = false;
            if (store.settings.is_branch_based_ordering) {
              if (branch_details["branch"] != item.resource.branch.id) {
                dispatch({
                  type: !item.promo
                    ? REMOVE_FROM_CART
                    : REMOVE_FROM_CART_PROMO_ITEM,
                  payload: !item.promo
                    ? item_index
                    : Math.abs(cart_quantity - item_index),
                });
                item_index--;
                if (!item.promo) cart_quantity--;
                itemWasRemoved = true;
                isRemoved = true;
              }
            }
            if (!isRemoved) {
              try {
                if (
                  !(await checkServiceIfAvailable(
                    item.resource.id,
                    item.id,
                    item.resourceSlot
                  ))
                ) {
                  dispatch({
                    type: !item.promo
                      ? REMOVE_FROM_CART
                      : REMOVE_FROM_CART_PROMO_ITEM,
                    payload: !item.promo
                      ? item_index
                      : Math.abs(cart_quantity - item_index),
                  });
                  item_index--;
                  if (!item.promo) cart_quantity--;
                  itemWasRemoved = true;
                }
              } catch {
                dispatch({
                  type: !item.promo
                    ? REMOVE_FROM_CART
                    : REMOVE_FROM_CART_PROMO_ITEM,
                  payload: !item.promo
                    ? item_index
                    : Math.abs(cart_quantity - item_index),
                });
                item_index--;
                if (!item.promo) cart_quantity--;
                itemWasRemoved = true;
              }
            }
          } else if (store_product.type_of_product === "composite") {
            if (item.is_preordered) {
              if (store_product.preorder_inventory - item.quantity < 0) {
                let allowableInventory = getAllowableInventory(
                  store_product.preorder_inventory,
                  store_product.increments,
                  store_product.min_addable_quantity
                );
                dispatch(
                  Edit_Cart(
                    allowableInventory,
                    store_product.price,
                    store_product.is_delivered,
                    store_product.charge_delivery,
                    store_product.preparation_time,
                    store_product.preordering_leadtime,
                    smart_promos,
                    item.promo ? true : false,
                    Math.abs(cart_quantity - item_index)
                  )
                );
                store_product.preorder_inventory = preciseNumber(
                  store_product.preorder_inventory - allowableInventory
                );
              } else {
                store_product.preorder_inventory = preciseNumber(
                  store_product.preorder_inventory - item.quantity
                );
              }
            } else {
              const currentProductInventory = getProductInventory(
                store_product,
                usedComponents
              );
              if (currentProductInventory - item.quantity < 0) {
                let allowableInventory = getAllowableInventory(
                  currentProductInventory,
                  store_product.increments,
                  store_product.min_addable_quantity
                );

                dispatch(
                  Edit_Cart(
                    allowableInventory,
                    store_product.price,
                    store_product.is_delivered,
                    store_product.charge_delivery,
                    store_product.preparation_time,
                    store_product.preordering_leadtime,
                    smart_promos,
                    item.promo ? true : false,
                    Math.abs(cart_quantity - item_index)
                  )
                );

                usedComponents = reduceComponentsInventories(
                  store_product,
                  allowableInventory,
                  usedComponents
                );
              } else {
                usedComponents = reduceComponentsInventories(
                  store_product,
                  item.quantity,
                  usedComponents
                );
              }
            }
          }

          if (!itemWasRemoved && !isEmpty(item.options)) {
            [usedComponents, ChangePrepTime] = Edit_Options(
              item,
              store_product,
              usedComponents,
              store.categories,
              ChangePrepTime,
              dispatch
            );
          }
          item_index += 1;
        } else {
          dispatch({
            type: !item.promo ? REMOVE_FROM_CART : REMOVE_FROM_CART_PROMO_ITEM,
            payload: !item.promo
              ? item_index
              : Math.abs(cart_quantity - item_index),
          });
          if (!item.promo) cart_quantity--;
        }
      }
    }

    if (ChangePrepTime) {
      dispatch({ type: SET_PREP_AND_LEAD_TIME });
    }

    dispatch({ type: SET_USED_COMPONENTS, payload: usedComponents });
  } catch (error) {
    console.log(error);
    instance
      .post("send_error/", {
        error: "got error in the CheckCart",
        info: error.toString(),
        browser: navigator.userAgent,
      })
      .then(dispatch({ type: CLEAR_CART }));
  }
};
const clearBranch = async (dispatch) => {
  dispatch({
    type: "CLEAR_BRANCH",
  });
  dispatch({
    type: "CLEAR_STORE",
  });
  dispatch({ type: "RESET_DELIVERY_TYPE" });
  dispatch({ type: "STOP_LOADING" });
};
const shouldResetBranch = (branch, selectedBranch) => {
  try {
    let store_branch;
    if (branch === -1) {
      return true;
    }
    if (!branch.settings.is_branch_based_ordering) return true;

    return false;
    if (selectedBranch.branch) {
      console.log(branch.branches, selectedBranch.branch, "iam here");
      store_branch = branch.branches.find(
        (b) => b.id === selectedBranch.branch
      );
      if (
        !store_branch ||
        (selectedBranch.isPickup && !store_branch.enable_pickup) ||
        (!selectedBranch.isPickup && !store_branch.enable_delivery)
      ) {
        console.log("iam here :(");
        return true;
      }
    }

    if (
      branch.settings.enable_branch_prioritization &&
      branch.settings.enable_branch_prioritization_staff
    ) {
      const selectedBdc = branch.branch_delivery_charges.find(
        (bdc) => bdc.id === selectedBranch.bdc
      );
      if (
        selectedBdc?.branch_is_busy &&
        selectedBdc?.other_branch_delivery_charges?.length
      ) {
        return true;
      }
    }
    return false;
  } catch (err) {
    return false;
  }
};

const shouldResetAddress = (customer, store) => {
  try {
    if (customer.address) {
      const address = customer.address;
      if (address.selectedDeliveryType === 1) {
        if (!store.settings.enable_pickup) return true;
        if (!address.pickupArea || !address.pickupArea === -1) {
          return true;
        }
        let branch = store.branches.find(
          (branch) => branch.id === address.pickupArea
        );
        if (!branch) {
          return true;
        }
      } else if (address.selectedDeliveryType === 0) {
        if (!store.settings.enable_delivery) return true;
        if (!address.area || address.area === -1) {
          return true;
        }
        const area = store.areas.find((area) => area.id === address.area);
        if (!area) {
          return true;
        }
      } else return true;

      if (store.settings.is_branch_based_ordering) return true;
    }
    return false;
  } catch (err) {
    return false;
  }
};
export const fetchCategory = (params, page) => {
  return async (dispatch, getState) => {
    try {
      let used_components = getState().store.used_components;

      dispatch({ type: "CATEGORY_LOADING" });
      let url;
      let availableCategories = [];
      getState().store.store.categories.forEach((category) => {
        if (
          !["newest", "most-selling", "discount-products"].includes(category.id)
        ) {
          availableCategories.push(category.id);
        }
      });
      let branchID = null;
      if (params.isBranchBased) {
        branchID = getState().branch?.branch;
        if (!params.bdc_id) url = "/category_product_list_fetch_branch/";
        else url = "/category_product_list_fetch_branch/";
      } else url = "/category_product_list_fetch_branch/";
      const res = await instance.post(url, {
        ...params,
        used_components: used_components,
        page: page || 1,
        availableCategories: availableCategories,
        branch_id: branchID,
        channel: getState().promise.src,
      });

      dispatch({
        type: CATEGORY_PRODUCT_LIST_FETCH,
        payload: { ...res.data, category_id: params?.category_id },
      });
    } catch (err) {
      console.error(err);
    }
  };
};

export const fetchStore = (
  cart,
  promo,
  history = null,
  forceCurrency = null,
  tableQrValid
) => {
  return async (dispatch, getState) => {
    try {
      const branch_details = getState().branch;
      const customer = getState().customers;
      const authUser = getState().auth.user;
      const promo_cart = getState().cart.promo_items;
      const deliveryTime = getState().deliveryTime;

      const full_cart = cart.concat(promo_cart);
      let productsIds = full_cart.length
        ? full_cart.map(({ id, parent }) => parent || id)
        : [];

      // let category = -1;
      if (window.location.pathname.startsWith("/product")) {
        productsIds.push(decodeURI(window.location.pathname).split("/")[3]);
      }
      const pathSegments = window.location.pathname.split("/").filter(Boolean);

      if (pathSegments[0] === "product" && pathSegments.length === 2) {
        productsIds.push(parseInt(decodeURI(pathSegments[1])));
      }

      let savedArea = null;
      if (getState().customers && getState().customers.address) {
        savedArea = getState().customers.address.area;
      }
      dispatch({ type: SECOND_LOADING });

      const applied_discounts = getState().cart.smart_promos;

      const res = await instance.post("/store/", {
        products: productsIds,
        savedArea: savedArea,
        address: getState().customers?.address,
        country_code: forceCurrency || getState().currency.selected,
        channel: getState().promise.src,
      });

      const store = res.data;

      dispatch({ type: "SET_SELECTED_CURRENCY", payload: store.country_code });

      const smart_promos = store.smart_promos;

      cart_quantity = cart.length;
      CheckCart(
        cart.concat(promo_cart),
        promo,
        store,
        dispatch,
        smart_promos,
        applied_discounts,
        branch_details,
        getState().promise.src
      );
      dispatch({
        type: "SET_CART_PRICE",
        payload: getOrderTotal(getState().cart.cart),
      });

      const language = localStorage.getItem("language");
      if (!language) {
        const defaultLanguage = store.settings.default_langauge;
        localStorage.setItem("language", defaultLanguage);
        dispatch({ type: SET_LANGUAGE, payload: defaultLanguage });
      } else {
        if (
          store.settings.default_langauge != language &&
          !store.settings.enable_arabic
        ) {
          const defaultLanguage = store.settings.default_langauge;
          localStorage.setItem("language", defaultLanguage);
          dispatch({ type: SET_LANGUAGE, payload: defaultLanguage });
        }
      }

      let skipProductsFetch = false;

      if (
        !!history &&
        store.settings?.enable_teasers_staff &&
        store.settings?.enable_teasers
      ) {
        if (!localStorage.getItem("customerID")) history.replace("/join");
        else {
          const validateRes = await instance.post(
            "/validate_teaser_customer_id/",
            { customerID: localStorage.getItem("customerID") }
          );
          if (!validateRes.data.success) history.replace("/join");
        }
      }

      if (
        !!history &&
        store.settings.is_branch_based_ordering &&
        store.settings.force_select_branch
      ) {
        const urlParameters = history?.location?.search || "";
        let tempLen = 2;
        if (window.location?.pathname?.endsWith("/")) tempLen = 3;
        if (window.location?.pathname?.split("/")?.length === tempLen) {
          const res = await instance.post(`/get_distributor_info/`, {
            check: true,
            slug: window.location?.pathname?.split("/")[1],
          });
          if (res.data !== 1) {
            skipProductsFetch = true;
            history.replace(`/select/branch${urlParameters}`);
          }
        } else {
          if (
            !(
              store.settings.disable_force_select_for_product &&
              window.location?.pathname?.startsWith("/product/")
            )
          ) {
            skipProductsFetch = true;
            history.replace(`/select/branch${urlParameters}`);
          }
        }
      }
      if (store?.settings?.currency_iso.toLowerCase() === "sar" || store?.settings?.currency_iso.toLowerCase() === "aed") {
        store.settings.currency_english = "";
        store.settings.currency_local = "";
      }

      dispatch({ type: FETCH_STORE, payload: store });
      dispatch({
        type: "RESET_FILTER",
      });
      if (!store.settings.enable_filter_and_sort) {
        dispatch({ type: "RESET_FILTER" });
      }
      if (
        !store.settings.enable_unknown_gift_recipient_location &&
        getState().promise?.unknown_location
      ) {
        dispatch({
          type: "SET_UNKNOWN_LOCATION",
          payload: false,
        });
      }

      let requests = [];
      // requests.push(
      //   instance.post("/delivery_charges_second_load/", {
      //     country_code: res.data.country_code,
      //   })
      // );
      if (!skipProductsFetch) {
        requests.push(
          instance.post("/products_second_load/", {
            used_components: getState().store.used_components || {},
            country_code: res.data.country_code,
            channel: getState().promise.src,
          })
        );
      }

      if (
        (store.settings.enable_car_qr || store.settings.enable_table_qr) &&
        tableQrValid
      ) {
        const params = new URLSearchParams(window.location.search);
        const parkingNumber =
          params.get("pn") ||
          params.get("tn") ||
          getState().customers?.address?.token ||
          getState().customers?.address?.parkingNumber;
        const branchID =
          params.get("b") || getState().customers?.address?.pickupArea;
        if (parkingNumber && branchID) {
          const branchObj = store.branches.find(
            (b) => b.id === parseInt(branchID)
          );
          if (branchObj) {
            dispatch({
              type: "MODIFY_ADDRESS",
              payload: {
                selectedDeliveryType: 1,
                pickupArea: parseInt(branchID),
                parkingNumber: tableQrValid,
                token: store.settings.enable_table_qr
                  ? parkingNumber
                  : undefined,
                area: null,
                country: null,
                gpsConfirmed: false,
                lat: "",
                lng: "",
                block: "",
                street: "",
              },
            });
            dispatch({ type: "DISABLE_MENU_MODE" });
            if (store.settings.enable_table_qr) {
              let tempName = getState().customers?.customerContact?.name;
              let tempPhone =
                getState().customers?.customerContact?.phone || "";
              if (
                !tempName ||
                tempName.includes("Table #") ||
                tempName.includes("Seat #")
              ) {
                if (
                  tempName?.includes("Table #") ||
                  tempName?.includes("Seat #")
                )
                  tempPhone = "";
                tempName = "";
              }
              dispatch({
                type: "SAVE_CONTACT",
                payload: store.settings.require_dine_in_contact_info
                  ? {
                      name: tempName,
                      phone: tempPhone,
                      email: "",
                      civilID: "",
                      birth_date: "",
                    }
                  : {
                      name: tableQrValid?.includes("Screen")
                        ? `Seat #${tableQrValid}`
                        : `Table #${tableQrValid}`,
                      phone:
                        branchObj.contact_number ||
                        store.settings.link_phone ||
                        store.settings.link_call_center ||
                        "+96500000000",
                      email: "",
                      civilID: "",
                      birth_date: "",
                    },
              });
            }
          }
        }
      } else if (getState().customers?.address?.parkingNumber) {
        dispatch({ type: "RESET_ADDRESS" });
      }
      axios
        .all(requests)
        .then(
          axios.spread((res2) => {
            if (!skipProductsFetch && res2?.data?.categories) {
              dispatch({
                type: PRODUCTS_SECOND_FETCH,
                payload: res2.data.categories,
              });
              dispatch({
                type: "CHECK_CATEGORIES",
                payload: res2.data.categories,
              });
              let newCart = getState().cart;
              dispatch({
                type: SET_CATEGORIES_MIN_ORDER,
                payload: getCategoriesMinOrders(
                  newCart.cart,
                  res2.data.categories
                ),
              });

              if (newCart.non_mingled_category) {
                let NewMingledCategory;
                if (!newCart.cart.length) NewMingledCategory = null;
                else {
                  NewMingledCategory = validateMingledCategory(
                    newCart.non_mingled_category,
                    res2.data.categories
                  );
                }
                if (NewMingledCategory !== newCart.non_mingled_category) {
                  dispatch({
                    type: SET_NON_MINGLED_CATEGORY,
                    payload: NewMingledCategory,
                  });
                }
              }
            }
            // dispatch({
            //   type: DELIVERY_CHARGES_SECOND_FETCH,
            //   payload: res3.data,
            // });
            if (shouldResetAddress(customer, store)) {
              dispatch({ type: "RESET_ADDRESS" });
            }
            if (smart_promos.length || applied_discounts.length) {
              dispatch({
                type: UPDATE_PROMOTION,
                smart_promos: smart_promos,
                customerAddress: customer?.address || {},
                customerBin: customer?.bin || {},
                branchDetails: branch_details,
                authUser: authUser,
                storeCategories: res2.data.categories,
                storeSettings: store.settings,
                deliveryTime: deliveryTime,
              });
            }
          })
        )
        .catch((errors) => {
          // react on errors.
          console.log(errors);
        });
    } catch (err) {
      console.error(err);
    }
  };
};
export const resetLocalStorage = () => {
  return async (dispatch) => {
    dispatch({ type: RESET_TO_INITIAL_STATE });
    dispatch({ type: CLEAR_CART });
  };
};
export const fetchBranch = (
  type,
  bdc_id,
  cart,
  promo,
  history,
  forceCurrency = null,
  tableQrValid,
  branchID
) => {
  return async (dispatch, getState) => {
    try {
      const promo_cart = getState().cart.promo_items;
      const full_cart = cart.concat(promo_cart);
      let productsIds = full_cart.length
        ? full_cart.map(({ id, parent }) => parent || id)
        : [];

      // let category = -1;
      let nextPage = getState().branch.nextPage;

      if (nextPage && nextPage.startsWith("/product")) {
        productsIds.push(decodeURI(nextPage).split("/")[3]);
      }
      if (window.location.pathname.startsWith("/product")) {
        productsIds.push(decodeURI(window.location.pathname).split("/")[3]);
      }

      const pathSegments = window.location.pathname.split("/").filter(Boolean);

      if (pathSegments[0] === "product" && pathSegments.length === 2) {
        productsIds.push(parseInt(decodeURI(pathSegments[1])));
      }

      //  else if (window.location.pathname.startsWith("/category")) {
      //   category = window.location.pathname.split("/")[2];
      // }
      let dc = null;
      if (getState().branch?.bdc) {
        dc = getState().branch?.bdc;
      }
      dispatch({ type: SECOND_LOADING });
      let branch_details = getState().branch;
      const applied_discounts = getState().cart.smart_promos;

      const res = await instance.post(`/get_branch/${type}/${bdc_id}/`, {
        products: productsIds,
        delivery_charge: dc,
        country_code: forceCurrency || getState().currency.selected,
        channel: getState().promise.src,
        // category: category,
      });
      const branch = res.data;

      if (
        !!history &&
        branch.settings?.enable_teasers_staff &&
        branch.settings?.enable_teasers
      ) {
        if (!localStorage.getItem("customerID")) history.replace("/join");
        else {
          const validateRes = await instance.post(
            "/validate_teaser_customer_id/",
            { customerID: localStorage.getItem("customerID") }
          );
          if (!validateRes.data.success) history.replace("/join");
        }
      }

      dispatch({ type: "SET_SELECTED_CURRENCY", payload: branch.country_code });
      const smart_promos = branch.smart_promos;

      cart_quantity = cart.length;
      if (shouldResetBranch(branch, branch_details)) {
        // dispatch({ type: "CLEAR_USER" });
        // localStorage.removeItem("stoken");
        // delete instance.defaults.headers.common.Authorization;
        // delete axios.defaults.headers.common.Authorization;
        dispatch({
          type: "CLEAR_BRANCH",
        });
        dispatch({
          type: "CLEAR_STORE",
        });
        dispatch({ type: "RESET_ADDRESS" });
        dispatch({ type: "STOP_LOADING" });

        let productsIds = full_cart.length
          ? full_cart.map(({ id, parent }) => parent || id)
          : [];

        // let category = -1;

        if (window.location.pathname.startsWith("/product")) {
          productsIds.push(window.location.pathname.split("/")[3]);
        }
        // else if (window.location.pathname.startsWith("/category")) {
        //   category = window.location.pathname.split("/")[2];
        // }

        // let dc = null;
        // if (getState().customers && getState().customers.address) {
        //   dc = getState().customers.address.delivery_charge;
        // }

        const applied_discounts = getState().cart.smart_promos;
        const promo_cart = getState().cart.promo_items;
        const res = await instance.post("/store/", {
          products: productsIds,
          country_code: forceCurrency || getState().currency.selected,
          channel: getState().promise.src,
          //delivery_charge: dc,
          // category: category,
        });

        const store = res.data;
        dispatch({
          type: "SET_SELECTED_CURRENCY",
          payload: store.country_code,
        });
        const smart_promos = store.smart_promos;
        cart_quantity = cart.length;
        const customer = getState().customers;
        const authUser = getState().auth.user;
        const deliveryTime = getState().deliveryTime;

        CheckCart(
          cart.concat(promo_cart),
          promo,
          store,
          dispatch,
          smart_promos,
          applied_discounts,
          branch_details,
          getState().promise.src
        );
        dispatch({
          type: "SET_CART_PRICE",
          payload: getOrderTotal(getState().cart.cart),
        });
        const language = localStorage.getItem("language");
        if (!language) {
          const defaultLanguage = store.settings.default_langauge;
          localStorage.setItem("language", defaultLanguage);
          dispatch({ type: SET_LANGUAGE, payload: defaultLanguage });
        } else {
          if (
            store.settings.default_langauge != language &&
            !store.settings.enable_arabic
          ) {
            const defaultLanguage = store.settings.default_langauge;
            localStorage.setItem("language", defaultLanguage);
            dispatch({ type: SET_LANGUAGE, payload: defaultLanguage });
          }
        }

        let skipProductsFetch = false;

        if (
          !!history &&
          store.settings?.enable_teasers_staff &&
          store.settings?.enable_teasers
        ) {
          if (!localStorage.getItem("customerID")) history.replace("/join");
          else {
            const validateRes = await instance.post(
              "/validate_teaser_customer_id/",
              { customerID: localStorage.getItem("customerID") }
            );
            if (!validateRes.data.success) history.replace("/join");
          }
        }

        if (
          !!history &&
          store.settings.is_branch_based_ordering &&
          store.settings.force_select_branch
        ) {
          const urlParameters = history?.location?.search || "";
          if (
            !(
              store.settings.disable_force_select_for_product &&
              window.location?.pathname?.startsWith("/product/")
            )
          ) {
            skipProductsFetch = true;
            history.replace(`/select/branch${urlParameters}`);
          }
        }
        dispatch({ type: FETCH_STORE, payload: store });
        dispatch({
          type: "RESET_FILTER",
        });
        if (!store.settings.enable_filter_and_sort) {
          dispatch({ type: "RESET_FILTER" });
        }
        if (
          !store.settings.enable_unknown_gift_recipient_location &&
          getState().promise?.unknown_location
        ) {
          dispatch({
            type: "SET_UNKNOWN_LOCATION",
            payload: false,
          });
        }

        if (!skipProductsFetch) {
          const res2 = await instance.post("/products_second_load/", {
            used_components: getState().store.used_components || {},
            country_code: res.data.country_code,
            channel: getState().promise.src,
          });

          dispatch({
            type: PRODUCTS_SECOND_FETCH,
            payload: res2.data.categories,
          });
          dispatch({
            type: "CHECK_CATEGORIES",
            payload: res2.data.categories,
          });

          let newCart = getState().cart;
          dispatch({
            type: SET_CATEGORIES_MIN_ORDER,
            payload: getCategoriesMinOrders(newCart.cart, res2.data.categories),
          });

          if (newCart.non_mingled_category) {
            let NewMingledCategory;
            if (!newCart.cart.length) NewMingledCategory = null;
            else {
              NewMingledCategory = validateMingledCategory(
                newCart.non_mingled_category,
                res2.data.categories
              );
            }
            if (NewMingledCategory !== newCart.non_mingled_category) {
              dispatch({
                type: SET_NON_MINGLED_CATEGORY,
                payload: NewMingledCategory,
              });
            }
          }
        }

        // const res3 = await instance.post("/delivery_charges_second_load/", {
        //   country_code: res.data.country_code,
        // });

        // dispatch({ type: DELIVERY_CHARGES_SECOND_FETCH, payload: res3.data });
        if (smart_promos.length || applied_discounts.length) {
          dispatch({
            type: UPDATE_PROMOTION,
            smart_promos: smart_promos,
            customerAddress: customer?.addres || {},
            customerBin: customer?.bin || {},
            branchDetails: branch_details,
            authUser: authUser,
            storeCategories: branch.categories,
            storeSettings: store.settings,
            deliveryTime: deliveryTime,
          });
        }
      } else {
        if (getState().branch.nextPage && history) {
          history.replace(getState().branch.nextPage, {
            prevState: getState().branch.prevState,
          });
          dispatch({ type: "SET_NEXT_PAGE", payload: null });
          dispatch({ type: "SET_PREV_STATE", payload: null });
        }
        branch_details = getState().branch;
        CheckCart(
          cart.concat(promo_cart),
          promo,
          branch,
          dispatch,
          smart_promos,
          applied_discounts,
          branch_details,
          getState().promise.src
        );
        dispatch({
          type: "SET_CART_PRICE",
          payload: getOrderTotal(getState().cart.cart),
        });
        const language = localStorage.getItem("language");
        if (!language) {
          const defaultLanguage = branch.settings.default_langauge;
          localStorage.setItem("language", defaultLanguage);
          dispatch({ type: SET_LANGUAGE, payload: defaultLanguage });
        } else {
          if (
            branch.settings.default_langauge != language &&
            !branch.settings.enable_arabic
          ) {
            const defaultLanguage = branch.settings.default_langauge;
            localStorage.setItem("language", defaultLanguage);
            dispatch({ type: SET_LANGUAGE, payload: defaultLanguage });
          }
        }

        if (
          branch.should_force_area_select &&
          window.location.pathname === "/" &&
          !getState().store?.store?.should_force_area_select
        ) {
          const urlParameters = history?.location?.search || "";
          history.replace(`/select/branch${urlParameters}`, {
            hideHeaderPlease: true,
          });
        } else if (getState().store?.store?.should_force_area_select) {
          branch.should_force_area_select = false;
          dispatch({ type: "RESET_SHOULD_FORCE_AREA_SELECT" });
        }

        if (branch?.settings?.currency_iso.toLowerCase() === "sar" || branch?.settings?.currency_iso.toLowerCase() === "aed") {
          branch.settings.currency_english = "";
          branch.settings.currency_local = "";
        }

        dispatch({
          type: FETCH_BRANCH,
          payload: branch,
          isPickup: type == "pickup" ? true : false,
        });
        dispatch({
          type: "RESET_FILTER",
        });

        if (!branch.settings.enable_filter_and_sort) {
          dispatch({ type: "RESET_FILTER" });
        }
        if (
          !branch.settings.enable_unknown_gift_recipient_location &&
          getState().promise?.unknown_location
        ) {
          dispatch({
            type: "SET_UNKNOWN_LOCATION",
            payload: false,
          });
        }

        if (
          (branch.settings.enable_car_qr || branch.settings.enable_table_qr) &&
          tableQrValid
        ) {
          const params = new URLSearchParams(window.location.search);
          const parkingNumber =
            params.get("pn") ||
            params.get("tn") ||
            getState().customers?.address?.token ||
            getState().customers?.address?.parkingNumber;
          const branchID = params.get("b") || getState().branch.branch;
          if (
            (parkingNumber && branchID) ||
            (getState().customers?.address?.parkingNumber &&
              getState().branch.branch)
          ) {
            const branchObj = branch.branches.find(
              (b) => b.id === parseInt(branchID)
            );
            if (branchObj) {
              dispatch({
                type: "MODIFY_ADDRESS",
                payload: {
                  selectedDeliveryType: 1,
                  pickupArea: parseInt(branchID),
                  parkingNumber: tableQrValid,
                  token: branch.settings.enable_table_qr
                    ? parkingNumber
                    : undefined,
                  area: null,
                  country: null,
                  gpsConfirmed: false,
                  lat: "",
                  lng: "",
                  block: "",
                  street: "",
                },
              });
              if (branch.settings.within_dinein_slot) {
                dispatch({ type: "DISABLE_MENU_MODE" });
              } else {
                const dineInID =
                  localStorage.getItem("dine_in_order_id") ||
                  getState().customers?.address?.dineInOrderID;
                if (!dineInID) {
                  dispatch({ type: "TURN_ON_MENU" });
                  dispatch({ type: "DISABLE_TABLE_QR" });
                  dispatch({ type: "RESET_ADDRESS" });
                }
              }
              if (branch.settings.enable_table_qr) {
                let tempName = getState().customers?.customerContact?.name;
                let tempPhone =
                  getState().customers?.customerContact?.phone || "";
                if (
                  !tempName ||
                  tempName.includes("Table #") ||
                  tempName.includes("Seat #")
                ) {
                  if (
                    tempName?.includes("Table #") ||
                    tempName?.includes("Seat #")
                  )
                    tempPhone = "";
                  tempName = "";
                }
                dispatch({
                  type: "SAVE_CONTACT",
                  payload: branch.settings.require_dine_in_contact_info
                    ? {
                        name: tempName,
                        phone: tempPhone,
                        email: "",
                        civilID: "",
                        birth_date: "",
                      }
                    : {
                        name: tableQrValid?.includes("Screen")
                          ? `Seat #${tableQrValid}`
                          : `Table #${tableQrValid}`,
                        phone:
                          branchObj.contact_number ||
                          branch.settings.link_phone ||
                          branch.settings.link_call_center ||
                          "+96500000000",
                        email: "",
                        civilID: "",
                        birth_date: "",
                      },
                });
              }
            } else {
              dispatch({ type: "RESET_ADDRESS" });
            }
          }
        } else if (getState().customers?.address?.parkingNumber) {
          dispatch({ type: "RESET_ADDRESS" });
        }

        dispatch({ type: "STOP_LOADING" });

        dispatch({ type: SECOND_LOADING });

        const res2 = await instance.post(`/products_second_load/`, {
          type: type,
          bdc_id: bdc_id,
          used_components: getState().store.used_components,
          country_code: res.data.country_code,
          branch_id: branchID,
          channel: getState().promise.src,
        });

        dispatch({
          type: PRODUCTS_SECOND_FETCH,
          payload: res2.data.categories,
        });
        dispatch({
          type: "CHECK_CATEGORIES",
          payload: res2.data.categories,
        });

        let newCart = getState().cart;
        dispatch({
          type: SET_CATEGORIES_MIN_ORDER,
          payload: getCategoriesMinOrders(newCart.cart, res2.data.categories),
        });

        if (newCart.non_mingled_category) {
          let NewMingledCategory;
          if (!newCart.cart.length) NewMingledCategory = null;
          else {
            NewMingledCategory = validateMingledCategory(
              newCart.non_mingled_category,
              res2.data.categories
            );
          }
          if (NewMingledCategory !== newCart.non_mingled_category) {
            dispatch({
              type: SET_NON_MINGLED_CATEGORY,
              payload: NewMingledCategory,
            });
          }
        }
        // const res3 = await instance.post(`/branch_based_third_load/`, {
        //   type: type,
        //   bdc_id: bdc_id,
        //   country_code: res.data.country_code,
        // });
        // dispatch({
        //   type: BRANCH_BASED_THIRD_FETCH,
        //   payload: res3.data,
        // });
        const customer = getState().customers;
        const authUser = getState().auth.user;
        const deliveryTime = getState().deliveryTime;
        // if (promo) {
        //   Check_Promo(promo, store, branch_details, dispatch, channel);
        // }

        if (smart_promos.length || applied_discounts.length) {
          dispatch({
            type: UPDATE_PROMOTION,
            smart_promos: smart_promos,
            customerAddress: customer?.address || {},
            customerBin: customer?.bin || {},
            branchDetails: branch_details,
            authUser: authUser,
            storeCategories: branch.categories,
            storeSettings: branch.settings,
            deliveryTime: deliveryTime,
          });
        }
      }
    } catch (err) {
      console.error(err);
    }
  };
};

export const setProduct = (product) => {
  return { type: SET_PRODUCT, payload: product };
};

export const check_required_options = (product, currentAddedOptions) => {
  let productOptions = product.options;
  let option;
  for (let productOption of productOptions) {
    if (productOption.is_required) {
      let optionGroups = [...productOption.groups];
      if (productOption.condition_parent) {
        const parentOption = productOptions.find(
          (o) => o.id === productOption.condition_parent_option
        );

        if (parentOption) {
          optionGroups = [...parentOption.groups];
        }
      }
      if (optionGroups.length <= 0) {
        optionGroups.push(null); // incase option is not assigned to any group , push null so it can loop
      }
      for (let i = 0; i < optionGroups.length; i++) {
        const group = optionGroups[i];

        const optionKey = group
          ? productOption.id + "-" + group
          : productOption.id;

        const parentKey = group
          ? productOption?.condition_parent_option + "-" + group
          : productOption?.condition_parent_option;

        let option = currentAddedOptions[optionKey];
        if (!option) {
          currentAddedOptions[optionKey] = {
            selected: 0,
            min: productOption.minimum,
            max: productOption.maximum,
            required: productOption.is_required,
            error: false,
            selectedOptions: {},
            totalPrice: 0,
          };
          option = currentAddedOptions[optionKey];
        }

        if (
          option.selected <= 0 &&
          (!productOption.condition_parent ||
            currentAddedOptions[parentKey]?.selectedOptions[
              productOption.condition_parent
            ])
        ) {
          return false;
        } else if (
          option.selected > 0 &&
          option.selected < productOption.minimum
        ) {
          return false;
        }
      }
    }
  }
  return true;
};

export const saveSearch = (categories) => {
  return { type: SAVE_SEARCH, payload: categories };
};

export const clearUsedComponents = () => {
  return { type: SET_USED_COMPONENTS, payload: {} };
};

export const loadVariants = (parentID) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: "VARIANTS_LOADING" });
      let used_components = getState().store.used_components;
      const isBranchBased =
        getState().store.store.settings.is_branch_based_ordering;
      const branchState = getState().branch;
      const orderType = branchState.isPickup ? "pickup" : "delivery";
      const bdc_id = branchState.isPickup
        ? branchState.branch
        : branchState.bdc;

      let params = {};

      let storeBranchId = null;
      if (getState().store.store.branches.length === 1) {
        storeBranchId = getState().store.store.branches[0].id;
      }

      if (isBranchBased)
        params = {
          storeBranchId: storeBranchId,
          type: orderType,
          bdc_id: bdc_id,
        };

      params = {
        ...params,
        used_components: used_components,
        parent_id: parentID,
        country_code: getState().currency.selected,
        channel: getState().promise.src,
      };
      const res = await instance.post("/load_variants/", params);

      dispatch({ type: "LOAD_VARIANTS", payload: res.data });
    } catch (err) {
      console.error(err);
    }
  };
};

export const loadOptions = (productID, categoryID) => {
  return async (dispatch, getState) => {
    try {
      const isBranchBased =
        getState().store.store.settings.is_branch_based_ordering;

      const branchState = getState().branch;
      const branch_id = branchState?.branch;

      let params = {};

      if (isBranchBased)
        params = {
          branch_id: branch_id,
        };

      params = {
        ...params,
        product_id: productID,
        country_code: getState().currency.selected,
      };

      const res = await instance.post("/load_options/", params);
      dispatch({
        type: LOAD_OPTIONS,
        payload: { ...res.data, category_id: categoryID },
      });
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  };
};

const getCategoriesMinOrders = (cart, categories) => {
  const newCategories_min_order = {};
  let parentCategories;
  let productMinCategories;

  cart.forEach((item) => {
    if (item.category_is_child) {
      ({ parentCategories } = getParentCategories(
        item.category_id,
        categories
      ));
    }
    productMinCategories = [item.category_id];
    if (parentCategories) {
      productMinCategories = productMinCategories.concat(parentCategories);
    }
    productMinCategories.forEach((cat) => {
      newCategories_min_order[cat] = preciseNumber(
        (newCategories_min_order[cat] || 0) +
          item.total_price * item.quantity +
          item.quantityExcludedOptionsTotal
      );
    });
  });
  return newCategories_min_order;
};

const validateMingledCategory = (mingledCategory, categories) => {
  const category = categories.find((cat) => cat.id === mingledCategory);
  if (!category || !category?.no_mingling) {
    mingledCategory = null;
  }
  return mingledCategory;
};

export const loadProductDetails = (productID, categoryID) => {
  return async (dispatch, getState) => {
    try {
      const isBranchBased =
        getState().store.store.settings.is_branch_based_ordering;

      const branchState = getState().branch;
      const branch_id = branchState?.branch;

      const countrycode = getState().currency?.selected;

      let params = {};

      if (isBranchBased)
        params = {
          branch_id: branch_id,
        };

      params = {
        ...params,
        product_id: productID,
        country_code: getState().currency.selected,
      };

      const res = await instance.post("/load_product_details/", params);
      dispatch({
        type: LOAD_PRODUCT_DETAILS,
        payload: {
          productDetails: res.data,
          product_id: productID,
          category_id: categoryID,
          country_code: countrycode,
        },
      });
      return true;
    } catch (err) {
      return false;
    }
  };
};
export const fetchProductFeedback = (
  productID,
  categoryID,
  page = 1,
  parentID = null
) => {
  return async (dispatch, getState) => {
    try {
      const res = await instance.post("/product_feedback/", {
        productID: productID,
        page: page,
      });
      dispatch({
        type: "LOAD_FEEDBACK",
        payload: {
          data: res.data,
          categoryID: categoryID,
          productID: productID,
          parentID: parentID,
        },
      });
    } catch (err) {
      console.error(err);
    }
  };
};

export const fetchDeliveryCharges = (country_code) => {
  return async (dispatch, getState) => {
    try {
      const res3 = await instance.post("/delivery_charges_second_load/", {
        country_code: country_code,
      });

      dispatch({ type: DELIVERY_CHARGES_SECOND_FETCH, payload: res3.data });
    } catch (err) {
      console.error(err);
    }
  };
};

export const loadBranchDetails = (branchId) => {
  return async (dispatch, getState) => {
    try {
      const res = await instance.post("load_branch_extra_details/", {
        branchId,
      });
      dispatch({
        type: LOAD_BRANCH_DETAILS,
        payload: res.data,
      });
    } catch (err) {
      return false;
    }
  };
};

const getOrderTotal = (cart) => {
  return cart.reduce((totalPrice, item) => {
    return (
      totalPrice +
      (item.total_price * item.quantity + item.quantityExcludedOptionsTotal)
    );
  }, 0);
};
